import AnnouncementsDashboard from '@views/instructor/AnnouncementsDashboard';
import CourseStatusDashboard from '@views/instructor/course/CourseStatusDashboard';
import CourseStatusPage from '@views/instructor/course/CourseStatusPage';
import InstructorServices from '@views/instructor/InstructorServices';
import React from 'react';
import GenericNavbarLayout from './GenericNavbarLayout';
import { NavLinkData } from '../util/navLinkData';
import { RouteLayoutProps } from './routeLayoutProps';
import 'firebase/firestore';
import InstructorAccount from '@views/instructor/auth/InstructorAccount';

const instructorRoutes: NavLinkData[] = [
  {
    text: 'Home',
    to: '/',
    component: AnnouncementsDashboard,
    inNavbar: true,
  },
  {
    text: 'Account',
    to: '/account',
    component: InstructorAccount,
    inNavbar: false,
  },
  {
    text: 'Courses',
    to: '/instructor/courses',
    component: CourseStatusDashboard,
    inNavbar: true,
  },
  {
    to: '/instructor/courses/:id',
    component: CourseStatusPage,
    inNavbar: false,
  },
  {
    text: 'Instructor Services',
    to: '/instructor/services',
    component: InstructorServices,
    inNavbar: true,
  },
];

const InstructorLayout: React.FC<RouteLayoutProps> = ({ baseRoutes }) => {
  const allowedRoutes = instructorRoutes.concat(baseRoutes);

  return <GenericNavbarLayout allowedRoutes={allowedRoutes}></GenericNavbarLayout>;
};

export default InstructorLayout;
